/**
 * Copies text to the clipboard, falling back to the legacy execCommand path.
 *
 * The async Clipboard API is missing or permission gated in several in-app
 * browsers, which are exactly the ones where the user needs to move the link to
 * a real browser.
 */
export async function copyText(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      // Fall through to the legacy path.
    }
  }

  const field = document.createElement("textarea");
  field.value = text;
  field.setAttribute("readonly", "");
  field.style.position = "fixed";
  field.style.top = "-1000px";
  field.style.opacity = "0";
  document.body.appendChild(field);

  try {
    field.select();
    field.setSelectionRange(0, text.length);
    return document.execCommand("copy");
  } catch (err) {
    return false;
  } finally {
    document.body.removeChild(field);
  }
}
